import { createListReducer } from 'app/redux/reducers/_reducer-factory/createListReducer';

const TEMPLATE_NAME = 'HEALTH_INSURANCE';

export default createListReducer(TEMPLATE_NAME);
